import React, { Component } from 'react';
import PropTypes from 'prop-types';
import merge from 'lodash/merge';

class Summary extends Component {

  constructor(props) {
    super(props);

    this.state = {
      isFixed: false,
    }
  }

  componentDidMount() {
    window.addEventListener('scroll', this.setIsFixed);
    window.addEventListener('resize', this.setIsFixed);
    this.setIsFixed();
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.setIsFixed);
    window.removeEventListener('resize', this.setIsFixed);
  }

  setIsFixed = () => {
    const isFixed = window.scrollY > 215 && window.innerWidth >= 972;
    if (isFixed !== this.state.isFixed) this.setState(merge({}, this.state, { isFixed }));
  }

  render() {
    const classNames = ['cartSummary'];
    if (this.state.isFixed) classNames.push('-isFixed');

    return (
      <div className={classNames.join(' ')} ref="elmt">
        <button type="button" className="cartSummary-edit" onClick={this.props.editCart}>{App.t('cart.edit')}</button>
        <h2 className="cartSummary-title">{App.t('cart.summary_title')}</h2>

        <ul className="cartSummary-items">
          {this.props.products.map((product, i) => {
            return (
              <li className="cartSummary-item" key={i}>
                <span className="cartSummary-itemName">
                  {product.quantity}x {product.bands} - {product.name} - {product.type} {product.includedType ? `+ ${product.includedType}` : null}
                </span>
                <span className="cartSummary-itemPrice">{product.price} €</span>
              </li>
            )
          })}

          {this.props.amounts.shipping !== null &&
            <li className="cartSummary-item -shipping">
              <span className="cartSummary-itemName">{App.t('cart.shipping_cost')}</span>
              <span className="cartSummary-itemPrice">{this.props.amounts.shipping} €</span>
            </li>
          }

          <li className="cartSummary-item -total">
            <span className="cartSummary-itemName -total">
              <strong className="cartSummary-itemNameImportant">{App.t('cart.total')}</strong>
              {App.t('cart.price_includes_vat')}
            </span>
            <span className="cartSummary-itemPrice -total">{this.props.amounts.total} €</span>
          </li>
        </ul>
      </div>
    )
  }

}

Summary.propTypes = {
  editCart:     PropTypes.func.isRequired,
  products:     PropTypes.array.isRequired,
  amounts:      PropTypes.object.isRequired,
};

export default Summary;
